import sidekickLogo from '../../assets/images/sidekick-logo.svg';
import sidekickLogo2 from '../../assets/images/sidekick-logo-2.svg';
import engageLogo from '../../assets/images/engage-logo.svg';
import investLogo from '../../assets/images/invest-logo.svg';
import chatBubbleIcon from '../../assets/images/chat-bubble-icon.svg';
import analyticsIcon from '../../assets/images/analytics-icon.svg';
import engageService, { EngageTile } from '../../features/engage/engageService';

export interface TileConfig {
    id: number;
    name: string;
    desc: string;
    subtitle: string;
    permission: string;
    imgSrc: string;
    imgsrcListingPage: string;
    route?: string;
    upcoming?: boolean;
    disable?: boolean;
}

export const TILES: TileConfig[] = [
    {
        id: 1,
        name: "Sidekick",
        desc: "AI Conversational Search",
        subtitle: "Your central place to review conversations, feedback, and insights to improve the Sidekick experience.",
        permission: "rag_admin_access",
        imgSrc: sidekickLogo,
        imgsrcListingPage: sidekickLogo2,
        route: "/sidekick",
    },
    {
        id: 2,
        name: "Engage",
        desc: "Actionable & Insightful Analytics",
        subtitle: "Explore insights, track performance, and stay informed with Analytics",
        permission: "engage_admin_access",
        imgSrc: engageLogo,
        imgsrcListingPage: engageLogo,
        route: "/engage"
    },
    {
        id: 3,
        name: "Invest",
        desc: "Micro-learning",
        subtitle: "This page serves as your central hub to help you navigate everything at Panviva",
        permission: "invest_admin_access",
        imgSrc: investLogo,
        imgsrcListingPage: investLogo,
        upcoming: true,
        disable: true,
    },
];

export interface SubTileConfig {
    id: number;
    title: string;
    desc: string;
    iconSrc?: string;
    /**
     * Alt text for the tile icon. Leave empty for decorative icons (default) —
     * the title and description are already announced via aria-labelledby /
     * aria-describedby on the wrapper, so a non-empty alt would double-announce.
     * Set explicitly when an icon carries information that the title alone
     * does not convey.
     */
    iconAlt?: string;
    route?: string;
}

export const SIDEKICK_SUB_TILES: SubTileConfig[] = [
    {
        id: 1,
        title: "Sidekick Chat History & Feedback",
        desc: "Understand how users interact with Sidekick by reviewing conversations and feedback to identify issues and improve your knowledge base.",
        iconSrc: chatBubbleIcon,
        iconAlt: 'Chat history and feedback',
        route: "/sidekick/chat-history",
    },
];

export const INVEST_SUB_TILES: SubTileConfig[] = [
    {
        id: 1,
        title: "Invest Analytics",
        desc: "Description for Invest",
    },
];

export type SubTileLoader = () => Promise<SubTileConfig[]>;

const ENGAGE_ANALYTICS_ROUTE = '/engage/analytics';

const toEngageSubTile = (tile: EngageTile, index: number): SubTileConfig => ({
    id: index + 1,
    title: tile.name,
    desc: tile.description,
    iconSrc: analyticsIcon,
    iconAlt: 'Analytics dashboard',
    route: `${ENGAGE_ANALYTICS_ROUTE}?appId=${encodeURIComponent(tile.appId)}&dashboardId=${encodeURIComponent(tile.dashboardId)}`,
});

const loadEngageSubTiles: SubTileLoader = async () => {
    const response = await engageService.getEngageTile();
    return (response.data || []).map(toEngageSubTile);
};

/**
 * Maps a tile route to a loader that returns its sub-tiles.
 * Static tiles wrap their array in Promise.resolve; dynamic tiles fetch from the backend.
 * To add a new module, register a loader here — ListingPage stays untouched.
 */
export const SUB_TILES_MAP: Record<string, SubTileLoader> = {
    "/sidekick": () => Promise.resolve(SIDEKICK_SUB_TILES),
    "/engage": loadEngageSubTiles,
    "/invest": () => Promise.resolve(INVEST_SUB_TILES),
};
